import { EpisodicActor } from '../..';

export interface CreateEpisodicActorResults {
	added: {
		EpisodicActor?: EpisodicActor[];
	};
	deleted: {};
	updated: {};
}
